import { request } from '../../api';
import { Methods } from '../../api.types';
import { LISTINGS_QUERY, SLUG_QUERY } from '../listings';
import { CreateRegisterInterest } from './createRegisterInterest.types';

export const REGISTER_INTEREST_QUERY = 'register-interest';

export const createRegisterInterest: CreateRegisterInterest = async ({
  token,
  slug,
  data,
}) =>
  await request({
    method: Methods.POST,
    query: `${LISTINGS_QUERY}/${SLUG_QUERY}/${slug}/${REGISTER_INTEREST_QUERY}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      ...data,
      passwordless: true,
    },
  });
